import React, { Component } from 'react';
import axios from 'axios';
import _ from 'lodash';
import { API_URL } from '../../partials/Globals';
import Errors from '../../partials/Errors';
import Message from '../../partials/Message';

export default class StudentShares extends Component {
    state = {
        errors: '',
        message: '',
        shares: '',
        hasRelation: false
    }

    constructor(props) {
        super(props);

        this.inputChange = this.inputChange.bind(this);
        this.submit = this.submit.bind(this);
    }

    inputChange(event) {
        event.preventDefault();
        this.setState({ [event.target.name]: event.target.value });
    }

    componentDidMount() {
        if (this.props.student.projects.length > 0) {
            let shares = '';
            let project = _.find(this.props.student.projects, {'id': this.props.project_id, 'pivot': { 'group_id': this.props.group_id }}); 
            if (project && project.pivot && project.pivot.shares) {
                shares = project.pivot.shares === null ? '' : project.pivot.shares;
            }
            this.setState({ shares });
            if (project) {
                this.setState({ hasRelation: true });
            }
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.student) {
            let project = _.find(nextProps.student.projects, {'id': this.props.project_id, 'pivot': { 'group_id': this.props.group_id }}); 
            if (project) {
                let shares = project.pivot.shares === null ? '' : project.pivot.shares;
                this.setState({ shares });
            }
            if (project) {
                this.setState({ hasRelation: true });
            } else {
                this.setState({ hasRelation: false });
            }
        }
    }
    submit(event) {
        event.preventDefault();
        
        axios.post(API_URL+'/admin/groups/'+this.props.group_id+'/projects/'+this.props.project_id, {
                users: [
                    {
                        user_id: this.props.student.id,
                        shares: this.state.shares
                    }
                ]
            })
            .then(response => {
                this.props.update();
                this.setState({ message: 'Sparat!' });
            })
            .catch(error => {
                // Valideringsfel
                if (error.response && error.response.status === 422) {
                    this.setState({ errors: error.response.data }); 
                }
                // Annat fel
                if (error.response && error.response.status === 400) {
                    this.setState({ errors: {1: 'Någonting gick fel, var god försök igen.'} })
                }
            });
    }

    render() {
        const { student } = this.props;

        return (
            <li className="shares">
                <Errors errors={ this.state.errors } />
                <Message message={ this.state.message } />

                <form onSubmit={ this.submit }>
                    <div className="bold">
                        { student.first_name }
                        { !this.state.hasRelation &&
                            <span className="right">(ej kopplad)</span>
                        }
                    </div>
                    <input type="number" name="shares" value={ this.state.shares } onChange={ this.inputChange } />
                    <input className="button purple" type="submit" value="Spara" /> 
                </form>
            </li>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/superadmin/Group/StudentShares.js